import { localize } from "@/i18n/translate";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Clock, Loader2, ShieldX } from "lucide-react";
import { CONTACT } from "@/data/content";
import { useAuth } from "./AuthContext";
import { usePortal } from "./i18n";
import { AuthLayout } from "./AuthLayout";
import { btnPrimary, btnSecondary } from "./ui";
export const StatusScreen = () => {
  const {
    user,
    reload,
    logout
  } = useAuth();
  const {
    p
  } = usePortal();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  const pending = user?.status === "pending";
  const Icon = pending ? Clock : ShieldX;
  const check = async () => {
    setBusy(true);
    await reload();
    setBusy(false);
  };
  return <AuthLayout>
      <div data-testid={pending ? "status-pending" : "status-rejected"}>
        <Icon className="h-9 w-9 text-signal" aria-hidden="true" />
        <h1 className="mt-6 font-display text-3xl font-extrabold tracking-[-0.03em] sm:text-4xl">
          {localize(pending ? p.status.pendingTitle : p.status.rejectedTitle)}
        </h1>
        <p className="mt-4 leading-relaxed text-mute">{localize(pending ? p.status.pendingText : p.status.rejectedText)}</p>
        <p className="mt-6 text-sm text-ink">
          <a href={`mailto:${CONTACT.email}`} className="underline underline-offset-4 hover:text-signal">{localize(CONTACT.email)}</a> ·{localize(" ")}
          <a href={CONTACT.phoneHrefs[0]} className="underline underline-offset-4 hover:text-signal">{localize(CONTACT.phones[0])}</a>
        </p>
        <div className="mt-10 flex flex-col gap-3 sm:flex-row">
          {localize(pending && <button type="button" onClick={check} disabled={busy} className={btnPrimary} data-testid="status-check-btn">
              {localize(busy && <Loader2 className="h-4 w-4 animate-spin" aria-hidden="true" />)} {localize(p.status.check)}
            </button>)}
          <button type="button" className={btnSecondary} data-testid="status-logout-btn" onClick={async () => {
          await logout();
          navigate("/");
        }}>
            {localize(p.logout)}
          </button>
        </div>
        <Link to="/" className="mt-8 inline-block text-sm text-mute underline-offset-4 hover:text-signal hover:underline">{localize(p.backToSite)}</Link>
      </div>
    </AuthLayout>;
};
